import { ParameterModel } from './parameter.model';

export class SapOrderModel {
  public id: number;
  public orderCode: string;
  public designation: string;
  public company: string;
  public codeCompany: string;
  public managmentCompany: string;
  public category: string;
  public subCategory: string;
  public systemStatus: string;
  public buLabel: string;
  public validationDate: any;
  public closingDate: any;
  public technicalClosingDate: any;
  public process: string;
  // Concat orderCode + designation
  public displayRow: string;
  public codeManagmentCompany: string;
  params: ParameterModel[];

  // Informations Importants for work commercial
  public workTitleVo: string;
  public workStatusProject: string;
  public miloCode: string;
  public costCenterCategory: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: SapOrderModel[] = [];
    jsons.forEach(json => {
      refs.push(new SapOrderModel().fromJSON(json));
    });
    return refs;
  }
}
